import { render, staticRenderFns } from "./LmDraggableFormComponent.vue?vue&type=template&id=20b25240&scoped=true&"
import script from "./LmDraggableFormComponent.vue?vue&type=script&lang=js&"
export * from "./LmDraggableFormComponent.vue?vue&type=script&lang=js&"
import style0 from "./LmDraggableFormComponent.vue?vue&type=style&index=0&id=20b25240&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b25240",
  null
  
)

export default component.exports